import {
  GET_ORDER_SUCCESS,
  ORDER_LIST_REQUESTING,
  ORDER_OBJECT_REQUESTING,
  LIST_ORDERS_SUCCESS,
  RESET_ORDER_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  query: null,
  recordCount: null,
  isListFetching: false,
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_ORDER_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }
    case ORDER_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case ORDER_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case LIST_ORDERS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.data.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        isListFetching: false,
        recordCount: action.payload.total
      };
    }
    case GET_ORDER_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export const getByOrderNumber = (data, orderNumber) => {
  const orderIds = Object.keys(data);
  const orderId = orderIds.find((id) => data[id].orderNumber === orderNumber);
  if (orderId) {
    return data[orderId];
  }
  return null;
};

export default reducer;
